import {
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog'
import { XMarkIcon } from '@heroicons/react/16/solid'
import { Button } from '../ui/button'
import React from 'react'
import useAppStore from '@/store/useAppStore'
import useOpenModalWindow from '../../hooks/useOpenModalWndow'
import useArchiveVault from '@/services/api/vault/useArchiveVault'
import { useForm } from 'react-hook-form'
import useDeleteVault from '@/services/api/vault/useDeleteVault'

export default function ArchiveEmptyVault({
  vault: archivedVault,
}: {
  vault: { id: number; name: string }
}) {
  const { handleSubmit } = useForm({})
  // const modalWindowState = useAppStore((state) => state.modalWindowState)
  // const archivedVault = useAppStore((state) => state.archivedVault)
  const { action: archiveVault } = useArchiveVault(archivedVault?.id)
  const { mutate: deleteVault } = useDeleteVault(archivedVault?.id)
  const { closeModal } = useOpenModalWindow()

  const onSubmit = (data) => {
    archiveVault(data)
    closeModal()
  }

  const handleDelete = () => {
    deleteVault()
    closeModal()
  }

  return (
    <form>
      <Dialog open={true}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Archive Vault - {archivedVault?.name}</DialogTitle>
            <DialogClose>
              <XMarkIcon onClick={() => closeModal()} />
            </DialogClose>
          </DialogHeader>

          <DialogBody>
            <p>
              The selected Vault has no transactions and a zero balance. You can
              choose to either archive it or permanently delete it. Please
              select one of the following options:
            </p>
            <ul className="list-inside list-disc pl-4">
              <li>
                Archive Vault: This will move the Vault to the Archive folder.
                It won't be available for use but can be restored later.
              </li>
              <li>
                Delete Vault: This will permanently remove the Vault and all its
                associated data.
              </li>
            </ul>
          </DialogBody>

          <DialogFooter>
            <DialogClose asChild>
              <Button
                onClick={handleSubmit(onSubmit)}
                type="button"
                variant="secondary"
              >
                Archive
              </Button>
            </DialogClose>

            <Button
              type="button"
              variant="destructive"
              onClick={() => handleDelete()}
            >
              Delete
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </form>
  )
}
